import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useStore } from "@/store";
import { Roles } from "@/helpers/enums/Roles";
const store = useStore();
  const selectedRole = localStorage.getItem("selectedRole");
  const realRole = localStorage.getItem("realRole");
  const selectedScopeId = localStorage.getItem("selectedScopeId");
  const partner = localStorage.getItem("partner");
  const partnerGuid = partner ? JSON.parse(partner)?.guid : "";
  const company = localStorage.getItem("company");
  const companyGuid = company ? JSON.parse(company)?.companyGuid : "";
  const site = localStorage.getItem("site");
  const siteGuid = site ? JSON.parse(site)?.key : "";
  const group = localStorage.getItem("group");
  const groupGuid = group ? JSON.parse(group)?.key : "";
  
 
  const body = {
    PdpLrpPageRole: selectedRole,
    SelectedScopeId: selectedScopeId,
    PartnerId : partnerGuid,
    CompanyId : companyGuid,
    SiteId : siteGuid,
    GroupId: groupGuid
  };
const data: any = {
    filter: {
        title: "filter",
        pageName: "filter",
        genre: "filter",
        ignoreSaveFilter: true,
        hideFilter: true,
        filters: [],
    },
    header: {
        navigation: [
        
                  ...(selectedRole !== Roles.PartnerAdmin
                      ? [
                        {
                            title: "pdpLrpList",
                            url: "pdp-lrp-list",
                            active: true,
                        },
                         
                        ]
                      : []),
                 ...(realRole === Roles.AGMSAdmin ||
                                 realRole === Roles.PartnerAdmin ||
                                 realRole === Roles.CompanyAdmin
                                 ? [
                                       {
                                           title: "pdpLrpSettings",
                                           url: "pdp-lrp-settings",
                                       },
                                   ]
                                 : [])
            
    ],
    
        buttonPosition: "pr-4 justify-content-between",
        buttons: [
            ...(selectedRole === Roles.AGMSAdmin
                ? [
                      {
                          title: "newPdpLrp",
                          icon: "add",
                          class: "primary mr-3",
                          link: "",
                          target: "#agPdpLrpModal",
                          toggle: "modal",
                          function: (module: any) => {
                              store.dispatch(
                                  GeneralActionTypes.SET_COMPKEY,
                                  store.getters.compKey + 1
                              );
                          },
                      },
                  ]
                : []),
                ...(selectedRole !== Roles.AGMSAdmin && selectedRole !== Roles.PartnerAdmin
                    ? [
                        
                        {
                            title: "pdpLrpSelect",
                            icon: "add",
                            class: "primary mr-3",
                            link: "",
                            target: "#agPdpLrpChooseModal",
                            toggle: "modal",
                            function: (module: any) => {
                              openModal();
                            },
                          },
                      ]
                    : []),
        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
               
                {
                    label: "pdpLrpName",
                    field: "serverName",
                    sortable: true,
                   
                },
                {
                    label: "ipUrl",
                    field: "urlHttp",
                    sortable: true,
                },
                ...(selectedRole === Roles.AGMSAdmin
                    ? [
                        {
                            label: "zone",
                            field: "zoneName",
                            sortable: true,
                        },
                      ]
                    : []),
                
                {
                    label: "pdpLrp",
                    field: "pdpServer",
                    sortable: true,
                    display: function (row: any) {
                        const pdp = row.pdpServer
                            ? `<span class="ag-badge badge badge-success p-1">PDP Server</span>`
                            : '';
                        const lrp = row.lrpServer
                            ? `<span class="ag-badge badge badge-success p-1">LRP Server</span>`
                            : '';

                        return (pdp || lrp) ? `<div>${pdp} ${lrp}</div>` : '';
                    },
                },
              
                
                {
                    label: "defaultSettings",
                    field: "defaultSettings",
                    display: function (row: any) {
                        return `
                            <input type="checkbox" 
                                    ${row.defaultSettings ? "checked" : ""} 
                                    style="pointer-events: none;" />`;
                    },
                },
                       
                
                
                ...(selectedRole !== Roles.AGMSAdmin && 
                    selectedRole !== Roles.PartnerAdmin && selectedRole !== Roles.CompanyAdmin
                      ? [
                            {
                                label: "isInherited",
                                field: "isInherited",
                                display: function (row: any) {
                                  return `
                                      <input type="checkbox" 
                                              ${row.isInherited ? "checked" : ""} 
                                              style="pointer-events: none;" />`;
                              },
                            },
                        ]
                      : []),
                  
                ...(selectedRole === Roles.AGMSAdmin
                    ? [
                          {
                              label: "actions",
                              field: "actions",
                              components: [
                                  {
                                      component: "tableAction",
                                      props: (row: any) => ({ row }),
                                  },
                              ],
                          },
                      ]
                    : []),
                
                ...(selectedRole === Roles.AGMSAdmin
                    ? [
                          {
                              label: "commands",
                              field: "commands",
                              components: [
                                  {
                                      component: "tableEditComponent",
                                      target: "#agPdpLrpModal",
                                  },
                                  {
                                      component: "tableDeleteComponent",
                                      class: "mr-2 ml-2",
                                  },
                              ],
                          },
                      ]
                    : []),
                    ...(selectedRole !== Roles.AGMSAdmin && selectedRole!== Roles.PartnerAdmin
                        ? [
                              {
                                  label: "commands",
                                  field: "commands",
                                  components: [
                                      {
                                          component: "tableDeleteComponent",
                                          class: "mr-2 ml-2",
                                      },
                                  ],
                              },
                          ]
                        : []),
            ],
            rows: [],
            sortable: {
                order: "serverName",
                sort: "asc",
            },
            total: 0,
            page: 1,
            pageSize: 5,
            isLoading: false,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_SERVERS, {
                    options: options,
                    filters: {},
                });
               
            },
        },
    },
};
function openModal() {
    const modal = document.getElementById("agPdpLrpChooseModal");
    if (modal) {
      modal.dispatchEvent(new Event("modal-open"));
    }
  }
export default data;
